import ReactGA from 'react-ga4';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
////////////////////////////////////////////////////////////////////
import { useCustomDispatch, useCustomSelector } from '@/core/redux/hooks';
import {
	Button,
	DailyRewardDetail,
	PageTitle,
	RewardDayItem,
} from '@/app/shared/components';
import { setDailyRewards } from '@/core/redux/slices';

/**
 * DailyReward
 *
 * This page shows the daily rewards for the user.
 * The user can claim the rewards by clicking on the day.
 * The page also shows the rewards that the user has already claimed.
 *
 * @returns {JSX.Element} The component.
 */
const DailyReward: React.FC = () => {
	/*********************
	// #region Hooks
	**********************/
	const dispatch = useCustomDispatch();
	const { t } = useTranslation();

	/*********************
	// #region Redux
	**********************/
	const { dailyRewards } = useCustomSelector((state) => state.rewards);

	/*********************
	// #region States
	**********************/
	const [selectedDay, setSelectedDay] = useState<number>(1);
	const [visibleDrawerDailyReward, setVisibleDrawerDailyReward] =
		useState<boolean>(false);
	const [dayAvailable, setDayAvailable] = useState<boolean>(false);

	/*********************
	// #region Observables
	**********************/
	useEffect(() => {
		ReactGA.send({
			hitType: 'pageview',
			page: '/daily-rewards',
			title: 'Daily Rewards',
		});
	}, []);

	useEffect(() => {
		setDayAvailable(false);
		dailyRewards.map((reward, index) => {
			if (reward.availableToday) {
				setDayAvailable(true);
				setSelectedDay(index + 1);
				return;
			}
		});
	}, [dailyRewards]);

	/*********************
	// #region Functions  
	**********************/
	const handleRefreshDrawer = (id: number) => {
		const rewards = [...dailyRewards];

		rewards[id - 1] = {
			...rewards[id - 1],
			availableToday: false,
			completed: true,
		};
		dispatch(setDailyRewards(rewards));
	};

	/*********************
	// #region Template
	**********************/
	return (
		<>
			<div className="flex flex-col justify-center items-center gap-6 pt-8 pb-20 mx-4">
				<div className="flex flex-col  justify-center items-center ">
					<img
						className={'dailyRewardImg'}
						src={process.env.VITE_DAILY_REWARD_PAGE_IMAGE}
					/>
					<PageTitle>{t('dailyReward.title')}</PageTitle>
					<p className="text-sm mt-2 ">
						{t('dailyReward.description')}
					</p>
				</div>
				<div className="grid grid-cols-4 lg gap-2 w-full">
					{dailyRewards.map((element, index) => {
						return (
							<RewardDayItem
								key={element.reward}
								reward={element.reward}
								rewardType={element.rewardType}
								numDay={index + 1}
								claimable={element.availableToday}
								isRewardCompleted={element.completed}
								onClickDay={(selectedDay) => {
									setSelectedDay(selectedDay);
									setVisibleDrawerDailyReward(true);
								}}
							/>
						);
					})}
				</div>
				<div className="mb-10 w-full">
					<Button
						variant={'secondary'}
						className="py-6 w-full text-sm rounded-lg"
						disabled={!dayAvailable}
						onClick={() => {
							setVisibleDrawerDailyReward(true);
						}}
					>
						{t('general.claim')}
					</Button>
				</div>
			</div>
			<DailyRewardDetail
				numDay={selectedDay}
				isOpen={visibleDrawerDailyReward}
				refresh={handleRefreshDrawer}
				setIsOpen={setVisibleDrawerDailyReward}
				reward={dailyRewards[selectedDay - 1]}
				// rewardTyp={dailyRewards[selectedDay - 1].reward}
			/>
		</>
	);
};

export default DailyReward;
